import { get, post } from './requests'

export const getAlert = key => get(['alerts'], { key })
export const readAlert = key => alertId => post(['alerts', alertId, 'read'], { key })
